// Imports Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef, MatDialog } from '@angular/material';

// Imports Aplicacion
import { DError, DContextoMuiscaServicio, DLogger, DContextoMuisca } from '@dian/core';
import { DRutServicios, DTipoContribuyente } from '@dian/api-rut';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DDocumento, DDocumentoAtributos, DFirmaElectronica, DListaDocumentos, DInfoResumenFormulario, DAniosFormato, DPeriodicidadFormato, DPeriodoFormato, DVersionRutaFormato } from '@dian/api-formulario';
import { DSimple2593IngresoServicios, DAnularFormulario, DPagoDeclaracion, DHistoricoSimple } from '@dian-api/simple2593-ingreso';
import { DOperacionesGeneralesServicio, DMensajes, DUtilidadesFormularioServicio, DOperacionesGeneralesIngresoServicio } from '@dian-cmp/formulario';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DBasicosParametricasServicios } from '@dian/api-basicos-parametricas';

import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    moduleId: module.id,
    selector: 'ingreso',
    templateUrl: 'ingreso.component.html',
    styleUrls: ['ingreso.component.css'],
    providers: [
        DNotificacionServicio,
        DReciboPagoDialogoServicio,
        DSimple2593IngresoServicios,
        DRutServicios,
        DUtilidadesFormularioServicio,
        DBasicosParametricasServicios
    ]
})
export class IngresoComponent implements OnInit {

    private versionesRuta: Array<DVersionRutaFormato>;
    public disableBtnPagoCuotas:boolean = true;
    public existenDocsPresentadosAnio:boolean = false;
    private anioSeleccionadoPresentados:number;
    private arrDocumentosDiligenciamiento:DListaDocumentos;
    private arrDocumentosPresentados:DListaDocumentos;
    private arrDocumentosDefinitivos:DListaDocumentos;
    private constribuyenteId:string;
    private configuracionFormulario:DFormularioConfiguracion;
    private esFirmanteElectronico: DFirmaElectronica;
    private enProceso:boolean = true;
    private estadosCarga = {
        pendientes: false,
        presentados: false,
        definitivos: false,
        anios: false
    };
    private habilitarFraccionAnio:boolean = false; // CAMBIE A TRUE SI EL FORMULARIO REQUIERE EL USO DE FRACCIÓN DE AÑO
    private hayFraccion:boolean = false;
    private hayInicial:boolean = false;
    private fraccionAnio:boolean = false;
    private firmaRequerida:boolean = false;
    private operacionesGenerales:DOperacionesGeneralesIngresoServicio; 
    private mostrarNuevoBorrador:boolean = true;
    private mostrarNuevoBorradorFraccion:boolean = false;   
    private mostrarDocumentosEnProceso:boolean = true;
    private mostrarDocumentosEnBorrador:boolean = true;
    private mostrarDocumentosEnDefinitivo:boolean = true;
    private periodicidadDeshabilitada:boolean = true;    
    private aniosFormato:DAniosFormato;
    private aniosFraccion:Array<number>;
    private anioSeleccionado:number;
    private anioSeleccionadoFraccion:number;
    private periodicidadFormato:DPeriodicidadFormato;
    private periodicidadSelecionada:string;   
    private periodosFormato:DPeriodoFormato;
    private periodoSeleccionado = null;  
    private tipoContribuyente: DTipoContribuyente; 
    private dAnularFormulario: DAnularFormulario;  
    private dPagoDeclaracion: DPagoDeclaracion;    
    public arreglopago:Array<any>; 
    private datosRespuesta:DContextoMuisca;     
    private datoImpuestosXPagar:any;
    /////Verificar condiciones ajustes
    private habilitaAjuste: boolean = true;
    private nitOrganizacion:string ='';
    private nitUsuario:string ='';
    public listaMunicipios: any;
    private municipiosBuscar = new Array<string>();

    /**
     * @constructs ConfiguracionSelectorComponent
     */
    constructor(
        private router: Router,
        private dialog:MatDialog,
        private dNotificacionServicio: DNotificacionServicio,
        private dReciboPagoServicio: DReciboPagoDialogoServicio,
        private dServicioRESTAPI: DSimple2593IngresoServicios,
        private dRutServicios: DRutServicios,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private logger: DLogger,
        private dutilidades: DUtilidadesFormularioServicio,
        private dBasicosParametricasServicios: DBasicosParametricasServicios,
    ) { 
        this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(this.dNotificacionServicio, this.dServicioRESTAPI, this.dialog); 
        this.configuracionFormulario = new DFormularioConfiguracion();
        this.arrDocumentosDiligenciamiento = new DListaDocumentos();  
        this.arrDocumentosPresentados = new DListaDocumentos();
        this.arrDocumentosDefinitivos = new DListaDocumentos();
        this.aniosFormato = new DAniosFormato();
        this.aniosFraccion = new Array<number>();
        this.periodicidadFormato = new DPeriodicidadFormato();
        this.periodosFormato = new DPeriodoFormato();
        this.tipoContribuyente = new DTipoContribuyente();
        this.esFirmanteElectronico = new DFirmaElectronica();
        this.versionesRuta = new Array<DVersionRutaFormato>(); 
        this.arreglopago = [];
        
    }

    /**
    * Interface for on init document.
    * @interface
    */
    ngOnInit() {
        console.log('I2593v1 1.1.0'); 
        setTimeout(() => {  
            this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta                     
        }, 50);        
    }

    /**
    * @desc Funcion para conocer si el contribuyente tiene firma electronica
    * @param {String} ideDocumento
    */
    public consultarFirmanteElectronico(ideDocumento:string) {
        let observableServicio = this.operacionesGenerales.consultarFirmanteElectronico(ideDocumento);
        observableServicio.subscribe(
            res => {
                this.esFirmanteElectronico = <DFirmaElectronica>res;
                this.firmaRequerida = this.esFirmanteElectronico.esFirmaElectronica;
                
                if (this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO && !this.firmaRequerida) {                       
                    let dialogFirma = this.dNotificacionServicio.mostrarDialogoError(DMensajes.SIN_FIRMA_ELECTRONICA);
                    dialogFirma.afterClosed().subscribe(result => {
                        this.operacionesGenerales.irPaginaDashboard(); 
                    });                        
                } else {
                    this.enProceso = true;
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let definitivos = this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO;
                    this.obtenerDocs(definitivos ? false : true); 
                    this.obtenerIdentidad();  
                    this.obtenerAnios();  
                    this.validarCargaCompletaFormulario(precarga);  
                   
                    this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);  

                   
                }                    
            }
        );            
    }

    /**
    * @desc Funcion para obtener todas las versiones del formulario que esten en Angular
    * @param {Number} ideFormato
    */
    public obtenerVersionesRuta(ideFormato:number){
        //this.impuestosXPagar('25935600000589','900158344' );   
        let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionesFormato.subscribe(
            res => { 
                this.versionesRuta = <Array<DVersionRutaFormato>>res;
                let anio = 0;
                for(let version of this.versionesRuta){
                    if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año
                        this.habilitarFraccionAnio = true;//Si hay fracción se activa el toolbar de fracción                        
                        if (anio < version.anioGravable) anio = version.anioGravable; 
                        this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
                    }
                }
                this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
                this.mostrarNuevoBorradorFraccion = this.habilitarFraccionAnio ? true : false;
                precargaProceso.close();
                this.enProceso = false;  
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
            }
        ); 
              
    }

    public validarActivarBotonPagoCuotas(){
        let periodicidad = this.periodicidadFormato.listaPeriodicidades.find(period=> period.nombre == this.periodicidadSelecionada);
        let idePeriodicidad;
        if(periodicidad.id == 1){//pendiente consultar este dominio y cruzar contra valores
            idePeriodicidad = 19110708;
        }else if(periodicidad.id == 4){
            idePeriodicidad = 19110706;
        }else if(periodicidad.id == 3){
            idePeriodicidad = 19110712;
        }else if(periodicidad.id == 6){
            idePeriodicidad = 19110705;
        }else if(periodicidad.id == 12){
            idePeriodicidad = 19110704;
        }
        let version = this.versionesRuta.find(ver=> ver.anioGravable == this.anioSeleccionado && ver.idPeriodicidad == idePeriodicidad && this.periodoSeleccionado.id <= ver.idPeriodo && ver.indModoFraccion == "N");        
        if(version && version.indPagoCuota == "S"){
            this.disableBtnPagoCuotas = false;
        }else{
            this.disableBtnPagoCuotas = true;
        }       
    }

    public redirigirFormulario(version:DVersionRutaFormato, params:string){
        if(version.indAccesoFormulario == "N"){
            this.dNotificacionServicio.mostrarDialogoError("El formulario solicitado no esta disponible para su diligenciamiento.");
        }else{
            window.location.href = location.origin + version.urlFormato + 'v' + version.version + '?' + params;
        } 
    }

    public validarPuedePagarCuota(anioSeleccionado){
        let docPresentadoAnio = this.arrDocumentosPresentados.infoFormularios.find( doc => doc.anio == anioSeleccionado);
        if(docPresentadoAnio){
            this.existenDocsPresentadosAnio = true;
        }
    }

    /**
    * @desc Funcion para validar si el formulario esta completamente cargado y remover la animacion de precarga
    * @ignore
    */
    private validarCargaCompletaFormulario(precarga) {
        let intervalId = setInterval(()=>{
            let bandera = true;
            let atributos = Object.keys(this.estadosCarga);

            for(let i in atributos){
                if(!this.estadosCarga[atributos[i]]){
                    bandera = false;
                    break;
                }
            }

            if(bandera){
                this.enProceso = true;
                precarga.close();
                clearInterval(intervalId);  
            }                        
        }, 500);
    }

    /**
    * @desc Funcion para obtener los aÃ±os
    */
    private obtenerAnios() {
        let observableServicio = this.dServicioRESTAPI.consultarAniosFormato();
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Años ", res);
                this.aniosFormato = <DAniosFormato>res;
                if (this.aniosFormato.anios.length === 1) {
                    this.anioSeleccionado = this.aniosFormato.anios[0];
                    this.obtenerPeriodicidad(this.anioSeleccionado);
                }                
                this.estadosCarga.anios = true;             
            },
            error => {
                this.estadosCarga.anios = true;
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de aÃ±os.");
            }
        );
    }

    /**
    * @desc Funcion para construir el listado de los años para fraccion de año
    */
    private obtenerAniosFraccion() {
        let anioActual = (new Date()).getFullYear();
        this.aniosFraccion.push(anioActual);
    }
    
    /**
    * @desc Funcion para verificar si el formulario debe de mostrar la seccion de fraccion de año
    * @param {Number} anio
    */
    private verificarFraccionAnio(anio:number) {
        let anioActual = (new Date()).getFullYear();
        this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;        
    }

    /**
    * @desc Funcion para obtener la periodicidad
    */
    private obtenerPeriodicidad(anio:number) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodicidad(anio);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Periodicidad ", res);
                this.periodicidadFormato = <DPeriodicidadFormato>res;
                if (this.periodicidadFormato.listaPeriodicidades.length === 1) {
                    this.periodicidadSelecionada = this.periodicidadFormato.listaPeriodicidades[0].nombre;
                    this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
                }
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodicidades.");
            }
        );
    }

    /**
    * @desc Funcion para obtener los periodos
    */
    private obtenerPeriodos(anio:number, periodicidad:string) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodos(anio, periodicidad);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Periodos ", res);
                this.periodosFormato = <DPeriodoFormato>res;
                if (this.periodosFormato.listaPeriodos.length === 1) {
                    this.periodoSeleccionado = this.periodosFormato.listaPeriodos[0];
                    this.validarActivarBotonPagoCuotas();
                }
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodos."); 
            }
        );
    }    

    /**
    * @desc Funcion para obtener los documentos pendientes y presentados
    * @param {boolean} definitivos
    */
    public obtenerDocs(definitivos?: boolean) {        
        this.obtenerDocsPendientes();
        this.obtenerDocsPresentados();
        if( definitivos) {
            this.obtenerDocsDefinitivos();
        } else {
            this.estadosCarga.definitivos = true;
        }     
    }

    /**
    * @desc Funcion para obtener los documentos pendientes
    */
    public obtenerDocsPendientes() {
        let observableDiligenciamiento = this.dServicioRESTAPI.consultarFormulariosEstado('pendiente'); 
        observableDiligenciamiento.subscribe(
            res => {            
                this.logger.info("Obteniendo Documentos Pendientes ", res);
                this.arrDocumentosDiligenciamiento = <DListaDocumentos>res;               
                this.arrDocumentosDiligenciamiento.infoFormularios.forEach((item, index) => {
                    if (item.modo === 'fraccion' || item.modo === 'fraccion_correccion'){
                        this.hayFraccion = true;
                    }
                    if (item.modo === 'inicial' || item.modo === 'correccion') {
                        this.hayInicial = true;                        
                    }
                });
                this.estadosCarga.pendientes = true;
            },
            error => {
                this.estadosCarga.pendientes = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los documentos presentados
    */
    public obtenerDocsPresentados(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('presentado');
        observablePresentados.subscribe(
            res => {
                this.logger.info("Obteniendo Documentos Presentados ", res);
                this.arrDocumentosPresentados = <DListaDocumentos>res;
                let arrPresentados = (<DListaDocumentos>res).infoFormularios;
                for( let presentadoInfo of arrPresentados)
                {   
                    if(presentadoInfo.anio==2023 && presentadoInfo.periodo =='1' )
                    {
                        if(Number(this.nitOrganizacion)==0)
                        {
                            this.impuestosXPagar(presentadoInfo.identificador.id,this.nitUsuario );
                        }
                        else 
                        {
                            this.impuestosXPagar(presentadoInfo.identificador.id,this.nitOrganizacion );
                        }
                       
                    }
                }
               // this.impuestosXPagar('25935600000589','900158344' );   
                this.estadosCarga.presentados = true;     
               
            },
            error => {
                this.estadosCarga.presentados = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los documentos definitivos
    */
    public obtenerDocsDefinitivos(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('definitivo');
        observablePresentados.subscribe(
            res => {

                this.logger.info("Obteniendo Documentos Definitivos ", res);
                this.arrDocumentosDefinitivos = <DListaDocumentos>res;
                for (let i of this.arrDocumentosDefinitivos.infoFormularios)
                {
                   this.consultarPagoDeclaracion(i);
                }
                this.estadosCarga.definitivos = true;                
            },
            error => {
                this.estadosCarga.definitivos = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los datos de identidad
    */
    private obtenerIdentidad(){
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();     
        observableServicio.subscribe(
            res => {
                this.datosRespuesta = <DContextoMuisca>res;
                this.nitOrganizacion = this.datosRespuesta.NitOrganizacion;
                this.nitUsuario = this.datosRespuesta.NitUsuario;
                this.consultarTipoContribuyente(this.datosRespuesta.ANombrePropio ? this.datosRespuesta.NitUsuario : this.datosRespuesta.NitOrganizacion);                            
            },                     
            error =>{  
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_CON_IDENTIDAD);                      
            }
        );    
    }

    /**
    * @desc Funcion para crear un nuevo borrador
    * @param {String} concepto
    */
    public crearNuevoBorrador(concepto: String) {
        let verificar = this.verificarPresentadoPorPeriodo(this.periodoSeleccionado.id.toString(), this.anioSeleccionado.toString());
        if(!verificar){ 


                let queryStringParams;
                if (concepto === 'inicial') {
                    queryStringParams = {
                        concepto: concepto, 
                        anio: this.anioSeleccionado, 
                        periodicidad: this.periodicidadSelecionada, 
                        periodo: this.periodoSeleccionado.id ? this.periodoSeleccionado.id : "null"
                    };
                } else {
                    queryStringParams = {
                        anio: this.anioSeleccionado || (this.anioSeleccionadoFraccion - 1),
                        concepto: concepto,
                        periodicidad: "anual", 
                        periodo: "1"              
                    };
                }
                
                let params = this.dutilidades.getQueryStringParams(queryStringParams,false);   

                this.enProceso = true;
                let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
                let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(this.anioSeleccionado, this.periodicidadSelecionada, this.periodoSeleccionado.id);
                observableVersionFormato.subscribe(
                    res => {
                        let version = <DVersionRutaFormato>res;       
                        precargaProceso.close();
                        this.enProceso = false;  
                        this.logger.info("URL Crear nuevo borrador: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                
                        this.redirigirFormulario(version,params);
                    },
                    error => {
                        precargaProceso.close();
                        this.enProceso = false;
                        this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la la versión del documento.");
                    }
                );  
        }else{
            this.dNotificacionServicio.mostrarDialogoError("Error de negocio : Error Diligenciamiento Inicial Ya ha presentado una declaración para este periodo, no es permitido diligenciar inicialmente de nuevo.");
        }  

    }

    /**
    * @desc Funcion para consultar el tipo de contribuyente
    * @param {string} nit del contribuyente
    */
    public consultarTipoContribuyente(nit: string) {
        let observableServicio = this.dRutServicios.consultarTipoContribuyente(nit);
        observableServicio.subscribe(
            res => {
                this.tipoContribuyente = <DTipoContribuyente>res;
                this.constribuyenteId = this.tipoContribuyente.id;           
            },
            error => {
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_OBTENIENDO_CONTRIBUYENTE);                
            }
        );
    } 

    /**
    * @desc Funcion para imprimir el formulario
    */
    public imprimirFormulario(idFormulario:string) {
        this.operacionesGenerales.imprimirFormulario(idFormulario);      
    }


    public validarPagoIntereses(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario:DInfoResumenFormulario){
        /*
        *Consultar DIL_HIS_DECLARACIONES_SIMPLE
        */
        let hisDeclaSimple:DHistoricoSimple;
        /*
        this.dServicioRESTAPI.obtenerDilHistSimple(idFormulario).subscribe(
            res=>{
                hisDeclaSimple = <DHistoricoSimple>res;
                if(hisDeclaSimple.idDocumentoPago){
                    if(hisDeclaSimple.valAnticipoSimple > 0){ //genera hoja dos
                        if(hisDeclaSimple.valImpConsumo > 0 || hisDeclaSimple.valImpVentas > 0){
                            //Generar recibo con con concepto 27 y los conceptos 27 y 58 en la hoja dos
                            this.pagarFormulario(idFormulario,anioGravable,periodo,objetoFormulario,[27,58],true);
                        }else{
                            //Generar recibo con hoja dos con concepto 27 y concepto 27 en la hoja dos                            
                            this.pagarFormulario(idFormulario,anioGravable,periodo,objetoFormulario,[27],true);          
                        }
                    }else{//no genera hoja 2
                        //Debe ser concepto 58
                        this.pagarFormulario(idFormulario,anioGravable,periodo,objetoFormulario,[58],true);
                    }
                }else{
                    //Flujo normal
                    this.pagarFormulario(idFormulario,anioGravable,periodo,objetoFormulario);
                }                
            }, error=>{
                console.log('Servicio generar liquidacion del recigo de pago ejecutado con error');
                this.dNotificacionServicio.mostrarDialogoError("Error consultando declaración");                     
            }
        );
        */
        
        this.pagarFormulario(idFormulario,anioGravable,periodo,objetoFormulario);
    }

    /**
    * @desc Funcion para pagar el formulario
    * @param {String} idFormulario
    * @param {String} anioGravable
    * @param {String} periodo
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public pagarFormulario(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario:DInfoResumenFormulario, conceptos?:Array<number>, esIntereses?:boolean) {

        if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {
            let mensajeConfirmarPago:string="Antes de oprimir el botón “Confirmar” del recibo oficial de pago 490, verifique que los valores, corresponden a los de su obligación. Si requiere modificar su pago, dar click, en el botón “Regresar” y anular este recibo electrónico SIMPLE, F2593, para ello presione el botón “Anular” en la sección de ingreso al formulario e realizar un nuevo diligenciamiento.<br> <b> Si da la opción “Guardar” al recibo de pago F490, tenga en cuenta que debe realizar el pago hoy mismo; </b>si no realiza el pago hoy, recuerde que cuando lo vaya a realizarl, debe generar un nuevo recibo de pago 490, por la opción “Pagar”, al inicio del proceso.";
            let tieneRecibo:boolean = this.validarTienePago(idFormulario);
            let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario);
            observableServicio.subscribe(
                res => {
                    let liquidacion = <DLiquidacionRecibo>res;
                    if (liquidacion) {

                        if(esIntereses){
                            if(conceptos){
                                let conceptos2593:Array<any> = [];
                                if(conceptos.includes(27)) conceptos2593.push({id:"27", nombre: "ANTICIPO REGIMEN SIMPLE"});
                                if(conceptos.includes(58)) conceptos2593.push({id:"58", nombre: "VENTAS ANUAL"});
                                liquidacion.conceptos = conceptos2593;
                            }
                            liquidacion.totalValorMonetario.impuesto = "0";
                            liquidacion.totalValorMonetario.interes = "0";
                            liquidacion.totalValorMonetario.sancion = "0";
                            liquidacion.totalValorMonetario.totalPagar = "0";
                        }

                        this.dReciboPagoServicio.mostrarDialogoReciboPago(this.datosRespuesta, this.firmaRequerida, liquidacion, null, mensajeConfirmarPago, esIntereses).afterClosed().subscribe((res) => {
                        //mostrarDialogoReciboPago(liquidacion,null,mensajeConfirmarPago,esIntereses).afterClosed().subscribe((res) => {
                            
                            this.arrDocumentosDefinitivos =  new DListaDocumentos();
                            this.obtenerDocs(true);  
                            console.log("Cerro",res);
                        });
                    }
                },
                error => {
                    console.log('Servicio generar liquidacion del recigo de pago ejecutado con error');
                    this.dNotificacionServicio.mostrarDialogoError("No hay valores monetario para generar el recibo de Pago"); 
                }
            );    
        } else {
            let modelo = new DDocumento();
            modelo.doc.cab.cs_id_4 = idFormulario;
            modelo.doc.cab.cs_id_1 = anioGravable;
            modelo.doc.cab.cs_id_3 = periodo ? periodo : "1"; 
            let contribuyente = this.tipoContribuyente.granContribuyente ? '3' : this.constribuyenteId;
            let atributos = objetoFormulario.atributos.docAtributos;
            let tipoDoc = atributos.esDefinitivo ? '2' : atributos.esPresentado ? '5' : null;
            this.operacionesGenerales.pagarFormulario(modelo, contribuyente, this.configuracionFormulario.NUMERO_FORMULARIO, tipoDoc);
        }   
    }   

    /**
    * @desc Funcion para editar el formulario
    * @param {Object} objetoFormulario
    */
    public editarFormulario(objetoFormulario:DInfoResumenFormulario){
        let esCorreccion:boolean = objetoFormulario.infoCorreccion.esCorreccion;
        let queryStringParams = null;
        if(esCorreccion) {
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: objetoFormulario.periodo ? objetoFormulario.periodo : "null",
                documento: objetoFormulario.infoCorreccion.ideDocumentoCorrige
            };            
        } else {           
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: objetoFormulario.periodo ? objetoFormulario.periodo : "null",
                idedocumento: objetoFormulario.identificador.id
            };
        }

        let params = this.dutilidades.getQueryStringParams(queryStringParams,false);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();      
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;  
                precargaProceso.close();
                this.enProceso = false;
                this.logger.info("URL Editar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                  
                this.redirigirFormulario(version,params);   
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;            
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la la versión del documento.");
            }
        );    
    }

    /**
    * @desc Funcion para consultar los formularios por aÃ±o gravable
    * @param {Number} anio
    */
    public consultarFormulariosPorAnio(anio:number){
        this.enProceso = true;
        this.anioSeleccionadoPresentados = anio;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let observableServicio = this.dServicioRESTAPI.consultarFormulariosEstado('presentado', anio); 
        observableServicio.subscribe(
            res => {
                this.arrDocumentosPresentados = <DListaDocumentos>res;
                precargaProceso.close();
                this.enProceso = false;
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
            }
        );   
    }

    /**
    * @desc Funcion para corregir un formulario presentado
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public corregirFormulario(objetoFormulario:DInfoResumenFormulario){  
        let esCorreccion = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        esCorreccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": esCorreccion;
        let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;

        let queryStringParams = {
            concepto: esCorreccion,
            anio: objetoFormulario.anio, 
            periodicidad: objetoFormulario.periodicidad, 
            periodo: periodo ? periodo : "null",
            documento: objetoFormulario.identificador.id
        };
        let params = this.dutilidades.getQueryStringParams(queryStringParams,false);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;    
                this.logger.info("URL Corregir formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la la versión del documento."); 
            }
        );            
    }

    /**
    * @desc Funcion para copiar los formularios cuando son definitivos
    * @param {DInfoResumenFormulario} objetoFormulario
    */

    public copiarFormulario(objetoFormulario: DInfoResumenFormulario) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let modo = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        modo = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": modo;
        let anio = Number(objetoFormulario.anio);
        let periodicidad = objetoFormulario.periodicidad;
        let periodo = objetoFormulario.periodicidad === 'anual' || !objetoFormulario.periodo ? 1 : objetoFormulario.periodo;
        let queryStringParams = {
            idedocumento: ideDocumento,
            concepto: modo, 
            anio: anio, 
            periodicidad: periodicidad, 
            periodo: periodo,
            clonar: true
        }; 
        let params = this.dutilidades.getQueryStringParams(queryStringParams,false);  

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;  
                this.logger.info("URL Copiar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la la versión del documento.");
            }
        );           
    } 

    public verificarPresentadoPorPeriodo(periodo:string,anio:string){
        let formulario = this.arrDocumentosPresentados.infoFormularios.find(formulario => formulario.periodo == periodo);
        if(formulario && formulario.anio == Number(anio)) return true;
        else return false;
    } 

     /**
    * @desc Funcion para copiar los formularios cuando son definitivos
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public anularFormulario(objetoFormulario: DInfoResumenFormulario, definitivo:boolean) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let observableVersionFormato = this.dServicioRESTAPI.anularFormulario(ideDocumento);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionFormato.subscribe(
            res => { 
                precargaProceso.close();
                this.enProceso = false;  
                this.dNotificacionServicio.mostrarDialogoInformacion("Se ha anulado el Recibo electrónico Simple: "+objetoFormulario.identificador.id);
                this.dAnularFormulario=<DAnularFormulario> res;
                //this.arrDocumentosDiligenciamiento= new DListaDocumentos();
                //this.rrDocumentosPresentados= new  DListaDocumentos();
                if(definitivo){
                    this.arrDocumentosDefinitivos =  new DListaDocumentos();    
                }                
                this.obtenerDocs(definitivo);   
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("No fue posible eliminar el Recibo electrónico Simple: "+objetoFormulario.identificador.id);
            }
        );           
    } 



    public confirmarAnulacion(objetoFormulario: DInfoResumenFormulario, definitivo:boolean){
        let confirmacion = this.dNotificacionServicio.mostrarDialogoConfirmacion("Al oprimir “Confirmar” se procede con la anulación del borrador de este recibo electrónico SIMPLE, F2593 y debe realizar un nuevo diligenciamiento");

        confirmacion.afterClosed().subscribe(
            res=>{
                if(res){
                    this.anularFormulario(objetoFormulario, definitivo);
                }                
            }
        );
    } 


         /**
    * @desc Funcion para copiar los formularios cuando son definitivos
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public consultarPagoDeclaracion(objetoFormulario: DInfoResumenFormulario) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerDeclaracionPago(ideDocumento);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionFormato.subscribe(
            res => { 
                precargaProceso.close();
                this.enProceso = false;  
                //this.dNotificacionServicio.mostrarDialogoInformacion("Se ha consultado el valor del recibo de pago del : "+objetoFormulario.identificador.id);
                this.dPagoDeclaracion=<DPagoDeclaracion> res;
                let  tienePago=false;
                if(this.dPagoDeclaracion.numFormularioPago != 0 )
                {tienePago=true;}
                let obj = {
                    nroDoucmento:  this.dPagoDeclaracion.numFormulario,
                    tienePago: tienePago
                };
                this.arreglopago.push(obj);
                //this.arrDocumentosDefinitivos =  new DListaDocumentos();

            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                //this.dNotificacionServicio.mostrarDialogoError("No fue posible consultar el valor del recibo de pago: "+objetoFormulario.identificador.id);
            }
        );           
    } 

    public validarTienePago(nroDoucmento){
        let pago = this.arreglopago.find(pago => pago.nroDoucmento == nroDoucmento);
        if(pago){
            return false;
        }else{
            return true;       
        }
    }
    public impuestosXPagar(ideDocumento, nit){
        // this.enProceso = true;
        // this.anioSeleccionadoPresentados = anio;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let observableServicio = this.dServicioRESTAPI.impuestosXPagar(ideDocumento,nit); 
        let boolmuestraMensaje:boolean=false;
        observableServicio.subscribe(
            res => {
                this.datoImpuestosXPagar = res;
               
                for (let impuestosXPagarRes of this.datoImpuestosXPagar)
                {
                    if( impuestosXPagarRes.pk && impuestosXPagarRes.att.indEstado != 'PG' )
                    {
                        this.habilitaAjuste=true;   //=impuestosXPagar(ideDocumento, nit);
                        boolmuestraMensaje=true;
                       this.municipiosBuscar.push(impuestosXPagarRes.pk.ideMunicipio);
                    }
                }
                if(boolmuestraMensaje)
                {
                    this.cargarCiudad(this.municipiosBuscar);
                }
                   precargaProceso.close();
                   this.enProceso = false;
                
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
            }
        ); 
        return observableServicio;
    }
    public cargarCiudad(codCiudades: Array<string>)
    {
        let strMunicipios:string ='';
        let cuenta=1;
        let tamano=codCiudades.length;
        for (let codCiudad of codCiudades)
        {
                let nombreCiudad:string='';
                let cuentaciudad=Number(codCiudad);
                if(cuentaciudad<10000)
                {
                    codCiudad='0'+codCiudad;
                }
                let observableCiudades = this.dBasicosParametricasServicios.obtenerCiudad(codCiudad);
                observableCiudades.subscribe(
                res => {
                    let respuesta:any=res;
                    nombreCiudad= respuesta.nombre;
                    if(cuenta>1)
                    {
                        strMunicipios=strMunicipios+",";
                    }
                    strMunicipios=strMunicipios+nombreCiudad;
                    cuenta++;
                    if(cuenta>tamano)  
                    {
                        this.dNotificacionServicio.mostrarDialogoInformacion("Si registró en el anticipo del bimestre 1 del año gravable 2023 un valor"
                        +" por <b>“Retenciones o autorretenciones a título de ICA practicadas antes de pertenecer al régimen SIMPLE”</b> (casilla 96) que no corresponde "
                        +"a su realidad económica en los siguientes Entes Territoriales <b>"+strMunicipios+"</b>, le informamos que puede ingresar por el"
                        +" botón de ajuste y revisar el valor de esta casilla en cada uno de estos municipios o distritos  y generar un nuevo 2593 junto con su "
                        +"respectivo pago, cuando haya lugar");
                    }
                       // this.dNotificacionServicio.mostrarDialogoInformacion(" Municipios concatenados :"+strMunicipios);  
                    
                
                },
                error => {
                    this.dNotificacionServicio.mostrarDialogoError("No fue posible encontrar la ciudad buscada");
                }
                
                ); 
        }
       
    }
   
    
    
  
}


// WEBPACK FOOTER //
// D:/GIT/Simple2593V5/Ingreso/ng_ingresosimple2593/src/app/components/ingreso/ingreso.component.ts